/* eslint-disable no-undef */
import { useEffect, useRef } from 'react';
import { Stack } from '@mui/material';
import Chip from '@mui/material/Chip';
import MapHelper from 'js/helpers/MapHelper';

const RectangleDeleteButton = (props) => {
    const contentElement = useRef();
    const instance = useRef();

    useEffect(() => {
        google?.maps?.importLibrary('streetView')
            .then(({ OverlayView }) => {
                const buttonInstance = new (class Button extends OverlayView {
                    constructor(bounds, content) {
                        super();
                        // Ensure position and anchor are valid
                        if (!bounds || !content) {
                            console.error("Invalid arguments passed to Button overlay constructor");
                            return;
                        }

                        this.SW = bounds.getSouthWest();
                        this.SE = {
                            lat: this.SW.lat(),
                            lng: bounds.getNorthEast().lng(),
                        }
                        this.content = content;
                    }

                    onAdd() {
                        this.container = document.createElement('div');
                        this.container.classList.add('button-overlay');
                        this.container?.appendChild(this.content.firstChild);
                        this.container.style.position = 'absolute';

                        const floatPane = this.getPanes().floatPane;
                        floatPane?.appendChild(this.container);
                    }

                    onRemove() {
                        if (this.container.parentElement) {
                            this.container.parentElement.removeChild(this.container);
                        }
                    }

                    getRectangleWidthInMeters() {
                        return google.maps.geometry.spherical
                            .computeDistanceBetween(this.SW, this.SE)
                    }

                    draw() {
                        const bottomMiddle = this.getRectangleWidthInMeters() / 2;
                        const pixels = MapHelper.convertMetersToPixels(bottomMiddle, props.map.getZoom(), this.SE.lng);

                        if (this.container) {
                            const muiChip = this.container.firstChild.firstChild.getBoundingClientRect();
                            const offsetX = muiChip.width / 2;
                            const offsetY = muiChip.height / 2;
                            const divPosition = this.getProjection().fromLatLngToDivPixel(this.SE);

                            this.container.style.width = 'unset';
                            this.container.style.top = `${divPosition.y - offsetY}px`;
                            this.container.style.left = `${(divPosition.x + pixels) - offsetX}px`;
                        }
                    }
                })(props.shape.getBounds(), contentElement.current);

                instance.current = buttonInstance;
                instance.current.setMap(props.map);
            });
        return () => {
            instance.current?.setMap(null);
            instance.current = null;
        };
    }, []);

    return (
        // need to hide react elements below.
        // we only need the ref to gain access in the DOM.
        // we need this since we will be using vanilla js to append html elements into google map library.
        // please feel free to try and remove the ref; the element it holds is only hidden by css.
        <div style={{ display: 'none' }} ref={contentElement}>
            <Stack direction="row" spacing={1}>
                <Chip label="Delete" onClick={props.onClick} onDelete={props.onClick} color="error" />
            </Stack>
        </div>
    );
};

export default RectangleDeleteButton;
